//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams} from '@/utils/util.js'

export default {
  name: "productCertificateDetailMore",
  components: {
  },
  data() {
    return {
      switchChecked:true,
      switchChecked1:true,
      switchChecked2:true,
      switchChecked3:true,
      switchChecked4:true,
      switchChecked5:true,
      switchChecked6:true,
      remark:''
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./src/pages/productCertificates/edit.vue